


















import { User, UsersApi } from '@/api';
import debounce from 'lodash.debounce';

import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';
import { AxiosError } from 'axios';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class UserAutocomplete extends Vue {
	@Prop({ required: true, type: String })
	private firstName!: string;

	@Prop({ required: false, type: String })
	private lastName!: string | null;

	@Watch('firstName')
	@Watch('lastName')
	public onNameFieldsChanged() {
		this.delayedSearch?.cancel();
		// If change not triggered by user selection.
		if (!this.userPreviouslySelected && this.firstName.length > 0) {
			this.delayedSearch = debounce(this.search, 350);
			this.delayedSearch();
		}
	}

	@Prop({ required: true, type: Function })
	private onUserSuggestionSelected!: (user: User) => void;

	public matchedUsers: User[] = [];
	public collapseVisible: boolean = true;

	private usersApi: UsersApi = new UsersApi();
	private toast: Toast = new Toast();
	private delayedSearch: ReturnType<typeof debounce> | null = null;
	private userPreviouslySelected: boolean = false;

	public async search(): Promise<void> {
		this.userPreviouslySelected = false;
		this.collapseVisible = true;
		const name = `${this.firstName} ${this.lastName ?? ''}`;
		const options = {
			params: {
				'filter[name]': name,
				'fields[users]': 'id,firstName,lastName,name,email,phone,preferences',
			},
		};
		try {
			const searchResponse = await this.usersApi.getUsers(options);
			this.matchedUsers = searchResponse.data.data ?? [];
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(
				e as AxiosError,
				'Failed to find user suggestions',
			);
			this.toast.makeToast(errorResponse.errorMessage, 'Error', 'danger');
		}
	}

	public onSelect(user: User): void {
		this.collapseVisible = false;
		this.userPreviouslySelected = true;
		this.onUserSuggestionSelected(user);
	}
}
